import { TreatmentResponse } from 'generated/index';

const PREFIX = 'CARE_RECEIVERS';

export const CARE_RECEIVERS_SESSION_STORAGE_KEYS = {
  SELECTED_CARE_RECEIVER: `${PREFIX}_SELECTED_CARE_RECEIVER`
};

/**
 * Tabs on this page. The values double as the `page` hash param, so another page can deep-link
 * straight to a tab — build such links from this enum rather than repeating the string.
 */
export enum TabType {
  PATIENT_INFO = 'patient-info',
  PRESCRIPTIONS = 'prescriptions',
  TREATMENTS = 'treatments'
}

/**
 * Preselects a care receiver when arriving from another page, handed over through session storage.
 * Deliberately just an id and a label: this page owns turning that into a Patient, the same way the
 * search does, so callers do not need to know how a Patient is assembled.
 */
export type CareReceiverHandover = {
  careReceiverId: string;
  name: string;
};

export interface Patient {
  id: string;
  entityId?: string;
  name?: string; // Display name for autocomplete
  firstName: string;
  lastName: string;
  dateOfBirth?: string;
  clientNumber?: string;
  displayName?: string;
  treatments?: TreatmentResponse[];
}
